import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import { SearchOutlined } from '@ant-design/icons';

import { FilterIcon } from '@/assets/icons/filter-icon';
import { FilterDrawer } from './Drawer';
import { useFileFilters } from './useFileFilters';
import { FilterButton, SearchFormItem, SearchInput } from './styles';

const SEARCH_FIELD = 'file_name_filter';

interface FiltersProps {
	onSearchFileNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function Filters({ onSearchFileNameChange }: Readonly<FiltersProps>): JSX.Element {
	const { fileName, isDrawerOpen, handleOpenDrawer, handleCloseDrawer, handleClearFilters, handleSubmitFilters } =
		useFileFilters();

	return (
		<>
			<Row align="middle" gutter={10} wrap={false}>
				<Col flex="auto">
					<SearchFormItem name={[SEARCH_FIELD]}>
						<SearchInput
							allowClear
							value={fileName}
							prefix={<SearchOutlined />}
							placeholder={I18n.get('Search file')}
							onChange={onSearchFileNameChange}
						/>
					</SearchFormItem>
				</Col>
				<Col flex="none">
					<FilterButton
						type="text"
						icon={<FilterIcon />}
						aria-label={I18n.get('Filters')}
						onClick={handleOpenDrawer}
					/>
				</Col>
			</Row>
			<FilterDrawer
				open={isDrawerOpen}
				onClose={handleCloseDrawer}
				onClear={handleClearFilters}
				onSubmit={handleSubmitFilters}
			/>
		</>
	);
}
